import { axiosApiService } from '../axios';

const EquipmentListAPIs = {
  EquipmentListGet: async function ({ page = 1, pageSize = 10, search = '', category = '', status = '', supervised = '' } = {}) {
    const response = await axiosApiService.get(`/admin_equipment_list/`, {
      params: {
        page: page,
        page_size: pageSize,
        search: search,
        category: category,
        status: status,
        supervised: supervised,
      },
    });
    return response.data;
  },

  AddInventory: async function (values, token) {
    try {
      const response = await axiosApiService.post(
        `/admin_equipment_list/`,
        values
      );
      return response;
    } catch (error) {
      console.error('Error adding Equipment:', error);
      // You can choose to return an error response or throw an error
      throw error;
    }
  },
};
export default EquipmentListAPIs;
